module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/jp-980c12c54fe2259234344611bde3f6da.svg";